module.exports = __webpack_public_path__ + "img/green_094.efa16041.png";